/* esm.sh - rxjs@7.8.1/dist/esm/internal/util/isArrayLike */
var t=e=>e&&typeof e.length=="number"&&typeof e!="function";export{t as isArrayLike};
//# sourceMappingURL=isArrayLike.mjs.map